import { wheelPreviewZoom, type PreviewCamera } from './preview-viewport';

export function bindPreviewWheel(element: HTMLElement, readCamera: () => PreviewCamera, updateCamera: (camera: PreviewCamera) => void, isPanning: () => boolean) {
  const onWheel = (event: WheelEvent) => {
    if (!event.altKey) return;
    event.preventDefault();
    if (isPanning()) return;
    const rect = element.getBoundingClientRect();
    updateCamera(wheelPreviewZoom(readCamera(), event.deltaY, event.deltaMode, rect.height, {
      x: event.clientX - rect.left - rect.width / 2,
      y: event.clientY - rect.top - rect.height / 2,
    }));
  };
  // React wheel handlers can be passive; only Alt-wheel should cancel page scrolling.
  element.addEventListener('wheel', onWheel, { passive: false });
  return () => element.removeEventListener('wheel', onWheel);
}
